/**
 * Error boundary to catch render errors and show a fallback
 * @param {string} [fallbackUrl='/gouverneur/dashboard'] - URL for "Retour au tableau de bord" button
 */
import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const errMsg = this.state.error?.message || '';
      const fallbackUrl = this.props.fallbackUrl ?? '/gouverneur/dashboard';
      return (
        <main className="error-boundary-fallback" style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto' }}>
          <h2>Une erreur s&apos;est produite</h2>
          <p>Cette page n&apos;a pas pu s&apos;afficher. Veuillez réessayer ou revenir au tableau de bord.</p>
          {errMsg && (
            <p style={{ fontSize: '0.875rem', color: '#666', marginTop: '0.5rem' }}>
              Détails : {errMsg}
            </p>
          )}
          <button
            type="button"
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{ marginTop: '1rem', marginRight: '0.5rem', padding: '0.5rem 1rem', cursor: 'pointer' }}
          >
            Réessayer
          </button>
          <button
            type="button"
            onClick={() => { window.location.href = fallbackUrl; }}
            style={{ marginTop: '1rem', padding: '0.5rem 1rem', cursor: 'pointer' }}
          >
            Retour au tableau de bord
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
